import { HypotheticalWaterfallInput } from "features/financial-reporting/HypotheticalWaterfallInput";
import { useHypotheticalWaterfallCreateDataRetrieveSuspense } from "gen/endpoints/financial-reporting/financial-reporting";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const HypotheticalWaterfallEditPage: React.FC = () => {
  const { fundFamilyId, endOfPeriodReportId } = useRequiredStringParams();

  const { data: hypotheticalWaterfallCreateData } =
    useHypotheticalWaterfallCreateDataRetrieveSuspense(
      fundFamilyId,
      endOfPeriodReportId,
    );

  return (
    <HypotheticalWaterfallInput
      fundIdToTransactionCodeToAmount={
        hypotheticalWaterfallCreateData.entity_id_to_transaction_code_id_to_amount
      }
      endOfPeriodReportId={endOfPeriodReportId}
    />
  );
};
